'use strict';

const config = {
  // 默认语言, 英文为en，中文为zh
  language: 'en',

  // env, aws or aliyun
  env: 'aws',

  // name
  name: 'online',

  // 静态文件cdn地址
  // staticCDNHost: 'https://web-static.shakker.ai/shakkerai_online',
  staticCDNHost: 'https://web-static2.shakker.ai/shakkerai_online',

  // 2.0 api
  apiHost: '',

  // devServer
  devServer: 'https://www.shakker.ai',

  // model upload
  modelUploadParallel: 20,
  modelUploadPartSize: 1024 * 1024,
  modelUploadTimeout: 10 * 60 * 1000,

  // nodejs
  port: 5299,

  // oss
  oss: {
    // oss region
    ossRegion: 'oss-us-east-1',

    // 持久化的bucket
    ossBucket: 'models-online-persist-us',
    cdnHost: 'https://models-online-persist.shakker.cloud',

    // 临时bucket
    ossBucketForSDTmp: 'models-online-tmp-us',
    cdnHostForSDTmp: 'https://models-online-tmp.shakker.cloud',
  },

  // s3
  s3: {
    // s3 region
    s3Region: 'us-west-2',

    // 持久化的bucket
    s3Bucket: 'models-online-persist',
    cdnHost: 'https://models-online-persist.shakker.ai',

    // 临时bucket
    s3BucketForSDTmp: 'models-online-tmp',
    cdnHostForSDTmp: 'https://models-online-tmp.shakker.ai',
  },
};

exports.config = config;
